import React from 'react';
// Import the corresponding CSS file
import './ContactUs.css';

const ContactUs = () => {
    // Data for office locations, updated with the new main address
    const officesData = [
        {
            name: 'BABA TRAVEL AND TOURISM (India)',
            addressLines: [
                '5-9-246/C, Shop No.1, SS Centre Building',
                'Opp St, George\'s Grammar School,',
                'Abids, Hyderabad, Telangana 500001'
            ],
            icon: 'ri-map-pin-2-line'
        },
        // --- You can add your other worldwide offices here if you have them ---
        // {
        //     name: 'Land Air Travels LLC (USA)',
        //     addressLines: [
        //         '19232 Golden Meadows Drive,',
        //         'German Town, Maryland MD2087,',
        //         'U.S.A'
        //     ],
        //     icon: 'ri-building-4-line'
        // },
    ];

    // Hero image for the contact page
    const heroStyle = {
        backgroundImage: `url('/assets/images/ContactUs.png')`,
    };

    return (
        <div className="main-content">
            <div className="contact-hero-section" style={heroStyle}>
                <div className="hero-overlay">
                    <div className="container text-center">
                        <h1 className="hero-heading">Contact Us</h1>
                        <p className="hero-subheading">We're here to help. Reach out to us anytime.</p>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div className="container">

                    {/* Top Contact Info Box - Updated */}
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="support-box text-center">
                                <i className="ri-customer-service-2-line support-icon"></i>
                                <h4>For Customer Support & Queries</h4>
                                <p className="mb-2">Get in touch with our dedicated support team.</p>
                                <div className="contact-details">
                                    <a href="mailto:support@babaair.com" className="support-link">
                                        <i className="ri-mail-line me-2"></i>support@babaair.com
                                    </a>
                                    <span className="contact-divider">|</span>
                                    <a href="tel:+919177656344" className="support-link">
                                        <i className="ri-phone-line me-2"></i>(+91) 91776 56344
                                    </a>
                                     <span className="contact-divider">/</span>
                                     <a href="tel:+919849787154" className="support-link">
                                        98497 87154
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Worldwide Offices Section */}
                    <div className="offices-section">
                        <h2 className="section-title">Our Office</h2>
                        <div className="row g-4 justify-content-center">
                            {officesData.map((office, index) => (
                                <div className="col-lg-6 col-md-8" key={index}>
                                    <div className="office-card h-100">
                                        <div className="office-icon">
                                            <i className={office.icon}></i>
                                        </div>
                                        <h5 className="office-name">{office.name}</h5>
                                        <address className="office-address">
                                            {office.addressLines.map((line, i) => (
                                                <span key={i}>{line}<br /></span>
                                            ))}
                                        </address>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Google Map Section - Updated */}
                    <div className="map-section">
                        <h2 className="section-title">Find Us On The Map</h2>
                        <div className="map-container">
                            <iframe 
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7614.804630794685!2d78.475533!3d17.39247!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9959b67d94dd%3A0x9da1d789abf4dc32!2sSS%20centre%20(Abids)!5e0!3m2!1sen!2sin!4v1752587726010!5m2!1sen!2sin" 
                                width="100%" 
                                height="450" 
                                style={{ border: 0 }} 
                                allowFullScreen="" 
                                loading="lazy" 
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Location of BABA TRAVEL AND TOURISM"
                            ></iframe>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ContactUs;